
;var ga_cid = '';
var ga_sid = '';
var ga_typ = '';
var ga_src = '';
var ga_mdm = '';
var ga_cmp = '';
var ga_cnt = '';
var ga_trm = '';
var ga_lid = '';
var ga_adid = '';
var ga_matchtype = '';
var ga_adposition = '';
var ga_device = '';
var ga_device_model = '';
var ga_lang = '';
var ga_placement = '';
var ga_target = '';
var ga_geo = '';
var ga_physical_geo = '';
var ga_network = '';

function ga_url_add(url) {
	return url + (url.indexOf('?') != -1 ? '&' : '?')
		+ '&ga_cid=' + encodeURIComponent(ga_cid + ':' + ga_sid)
		+ '&ga_typ=' + encodeURIComponent(ga_typ)
		+ '&ga_src=' + encodeURIComponent(ga_src)
		+ '&ga_mdm=' + encodeURIComponent(ga_mdm)
		+ '&ga_cmp=' + encodeURIComponent(ga_cmp)
		+ '&ga_cnt=' + encodeURIComponent(ga_cnt)
		+ '&ga_trm=' + encodeURIComponent(ga_trm)
		+ '&ga_lid=' + encodeURIComponent(ga_lid)
		+ '&ga_adid=' + encodeURIComponent(ga_adid)
		+ '&ga_matchtype=' + encodeURIComponent(ga_matchtype)
		+ '&ga_adposition=' + encodeURIComponent(ga_adposition)
		+ '&ga_device=' + encodeURIComponent(ga_device)
		+ '&ga_device_model=' + encodeURIComponent(ga_device_model)
		+ '&ga_lang=' + encodeURIComponent(ga_lang)
		+ '&ga_placement=' + encodeURIComponent(ga_placement)
		+ '&ga_target=' + encodeURIComponent(ga_target)
		+ '&ga_geo=' + encodeURIComponent(ga_geo)
		+ '&ga_physical_geo=' + encodeURIComponent(ga_physical_geo)
		+ '&ga_network=' + encodeURIComponent(ga_network)
		;
}

function ga_email() {
	try {
		let event_type = 'email';
		dataLayer.push({'event':'registration_began_' + event_type});
	} catch (e) {
		console.error(e, e.stack);
	}
}

function ga_reg_block_click(event_type) {
	try {
		dataLayer.push({'event':'reg_block_click_' + event_type});
	} catch (e) {
		console.error(e, e.stack);
	}
}

var ga_click_processed = false;
function ga_click(event_type, url) {
	ga_click_url = ga_url_add(url);
	try {
		//setTimeout(function() { document.location.href = ga_click_url; }, 1000);
		dataLayer.push({
			'event':'registration_began_' + event_type,
			'eventCallback': function () {
				if (!ga_click_processed) document.location.href = ga_click_url;
				ga_click_processed = true;
			}
		});
		setTimeout(function() { // Analytics blocked
			if (!ga_click_processed) document.location.href = ga_click_url;
			ga_click_processed = true;
		}, 1000)
	} catch (e) {
		console.error(e, e.stack);
		if (!ga_click_processed) document.location.href = ga_click_url;
		ga_click_processed = true;
	}
}
;var App = App || {};

App.validate = {
	email: /^[\w\d]+([.-]?[\w\d]+)*@[\w\d]+([.-]?\w+)*(\.\w+)+$/,
}

App.auth = {
	partner: false,
	partner_integrator: false,
	account_force: false,
	endpoint: '/api/user/',
	url_base: '',
	force_new: false,
	plan_type: '',
	lang: 2,
	//endpoint: 'https://worksection.com/api/user/',

	last_tab: '',
	set_tab: function(tab, noani) {
		last_tab = tab;
		$('#auth').attr('class', tab + (noani ? ' noani' : '')).show().css({height: $('#auth .' + tab).outerHeight()});
		if (noani) window.setTimeout(function () {
			$('#auth').removeClass('noani');
		}, 0);
	},

	fix_height: function() {
		if (last_tab) $('#auth').css({height: $('#auth .' + last_tab).outerHeight()});
	},

	show: function (start_tab, callback) {
		if (!start_tab) start_tab = '';
		window.lastScrolltop = $(window).scrollTop();
		if ($(window).width() < 600) $(window).scrollTop(0);
		$('body').addClass('bd_auth');
		if ($('#auth').length) {
			$('#auth').attr('class', '');
			if (!$('#auth').attr('class')) {
				if (start_tab) {
					if (typeof callback == 'function') callback();
					App.auth.set_tab(start_tab, true);
				} else {
					App.auth.set_tab('register');
				}
			}
			if ($('#auth').hasClass('register')) setTimeout(function () {
				$('#auth.register .register form').find('.input-email').focus();
			}, 500);
		} else {
			let authorized = $('#header .profile').length ? 1 : 0;
			$('<div />').attr('id', 'auth_overlay').appendTo('body');
			let url = '/api/user/?action=' + (App.auth.partner ? 'auth_partner_html&authrozied=' + authorized : 'auth_html') + '&id_lang=' + ($('body').attr('data-lang') || App.auth.lang) + (App.auth.force_new ? '&is_v20=1' : '') + (App.auth.plan_type ? '&plan_type=' + App.auth.plan_type : '') + ($('input[name=promocode]').val() ? '&promocode=' + $('input[name=promocode]').val() : '');

			$.ajax({
				url: url,
				success: function (html) {
					$('body').append(html).addClass('bd_auth_load');
					App.auth.init();
					if (start_tab) {
						if (typeof callback == 'function') callback();
						App.auth.set_tab(start_tab, true);
					} else {
						App.auth.set_tab('register');
					}
					if ($('#auth').hasClass('register')) setTimeout(function () {
						$('#auth.register .register form').find('.input-email').focus();
					}, 500);
					setTimeout(function () {
						$('#auth > .hidden').removeClass('hidden');
					}, 50);
				}
			});
		}
	},

	init: function () {
		$('#auth .close, #auth .logo').click(this.hideLayouts);

		$('#auth .login form').submit(function () {
			let email = $('#auth .login form .input-email').val();
			let pass = $('#auth .login form #password').val();
			let save_login = $('#auth .login form .input[name=save_login]').attr('checked') ? 1 : 0;
			let id_lang = $('body').attr('data-lang') || App.auth.lang;
			let action = App.auth.partner ? 'partner_login' : 'login_promo';

			$.ajax({
				type: 'POST',
				url: App.auth.endpoint,
				data: {
					email: email,
					action: action,
					password: pass,
					id_lang: id_lang,
					save_login: save_login
				},
				dataType: 'json',
				success: App.auth.process_login_response
			});
			return false;
		});

		$('#auth').on('click', '.login_multy .accounts a.param-acc', function () {
			let email = $('#auth .login form .input-email').val();
			let pass = $('#auth .login form #password').val();
			let domain = $(this).attr('data-url');
			let action = App.auth.partner ? 'partner_login' : 'login_promo';

			if ($(this).attr('data-redirect')) document.location.href = $(this).attr('data-url'); else {
				$.ajax({
					type: 'POST',
					url: App.auth.endpoint,
					data: {
						email: email,
						action: action,
						password: pass,
						domen: domain.replace('/login/', '')
					},
					dataType: 'json',
					success: function (json) {
						if (json.status === "redirect") {
							document.location.href = json.url ? json.url + (json.query ? '?' + json.query : '') : '';
						}
					}
				});
			}
			return false;
		});

		$('#auth').on('click', '.forgot_multy .accounts a.param-acc', function () {
			App.auth.forgot($(this).attr('data-domen'));
			return false;
		});

		$('#auth').on('click', '.register_multy .accounts a.param-acc', function () {
			document.location.href = $(this).attr('data-url');
			return false;
		});

		$('#check-russia-btn').on('click', function () {
			const helpUrl = $(this).attr('href');
				$.ajax({
					url: '/check_russian_ip',
					success: function (json) {
						console.log(json.is_russian);
						if (!json.is_russian) {
							const modal_height = $('#auth').innerHeight();
							const alert_height = $('#auth .disable_reg_alert').outerHeight();
							$('#auth .register').removeClass('disable_reg');
							$('#auth').css('transition', 'none');
							$('#auth .disable_reg_alert').slideUp(200)
							$('#auth').animate({height: modal_height - alert_height - 40 + 'px'}, 200, function () {
								$('#auth').css('transition', 'height 0.5s ease 0.5s')
							});
						} else {
							window.location.replace(helpUrl);
						}
					},
					dataType: 'json'
				})

			return false;
		});

		$('#auth .register form').submit(function () {
			let email = $('#auth .register form .input-email').val();
			let id_lang = $('body').attr('data-lang') || App.auth.lang;
			//let is_v20 = $('#auth .register form input[name=is_v20]').val() || App.auth.force_new;
			let is_v20 = true;

			$('#auth .register_success .text-email').text(email);
			ga_email();
			if (email.match(App.validate.email)) {
				$('#auth').addClass('loading');
				$.ajax({
					type: 'POST',
					url: App.auth.endpoint,
					data: {
						email: email,
						hash: md5('20' + "25" + document.location.host + email),
						action: App.auth.partner ? 'partner_register' : 'register_by_email',
						force: $('#auth .register form').attr('data-force') || '',
						force_email_validation: $('#auth .register form').attr('data-force-validation') || '',
						is_v20: is_v20 ? 1 : 0,
						plan_type: App.auth.plan_type,
						id_lang: id_lang,
						promocode: $('input[name=promocode]').val(),
						ga_cid: ga_cid + ':' + ga_sid,
						ga_typ: ga_typ,
						ga_src: ga_src,
						ga_mdm: ga_mdm,
						ga_cmp: ga_cmp,
						ga_cnt: ga_cnt,
						ga_trm: ga_trm,
						ga_lid: ga_lid,
						ga_adid: ga_adid,
						ga_matchtype: ga_matchtype,
						ga_adposition: ga_adposition,
						ga_device: ga_device,
						ga_device_model: ga_device_model,
						ga_lang: ga_lang,
						ga_placement: ga_placement,
						ga_target: ga_target,
						ga_geo: ga_geo,
						ga_physical_geo: ga_physical_geo,
						ga_network: ga_network
					},
					dataType: 'json',
					success: App.auth.process_register_response,
					complete: function () {
						$('#auth').removeClass('loading');
					}
				});
			}
			return false;
		});

		$('#auth .register_multy .part-bottom a.btn').click(function () {
			if ($(this).attr('data-url')) {
				if ($('input[name=promocode]').length) $(this).attr('data-url', $(this).attr('data-url') + '&promocode=' + $('input[name=promocode]').val());
				if ($(this).attr('data-ga')) ga_click($(this).attr('data-ga'), $(this).attr('data-url'));
				else document.location.href = $(this).attr('data-url');
			} else $('#auth .register form').attr('data-force', 'yes').submit();
		})
		$('#auth .register .input-email').on('keyup blur paste', function () {
			var email = $(this).val();
			if (email.match(App.validate.email)) {
				if (!$('#auth .register .btn-default').hasClass('effect-green')) App.auth.showEffect();
				$('#auth .register .btn-default').addClass('effect-green').removeClass('effect-yellow');
			} else if (email) {
				$('#auth .register .btn-default').addClass('effect-yellow').removeClass('effect-green');
			} else {
				$('#auth .register .btn-default').removeClass('effect-yellow effect-green');
			}
		});

		$('#auth .logged .auth-social a.btn').click(function () {
			App.auth.set_tab('login');
		});

		$('#auth .auth-social a.small').click(function () {
			App.auth.massLogout();
		});

		$('#auth .forgot form').submit(() => App.auth.forgot());

		$('#remember_form').click(function () {
			$('#auth .forgot form .input-email').val($('#auth .login form .input-email').val());
			App.auth.set_tab('forgot');
		});

		$('#auth .register_success .code_step1 form').submit(function () {
			let blink = false,
				me = $(this),
				code = '',
				parent = $(this).parent();
				parent.find('.code_4digit input').each(function() {
				if (!this.value) blink = true;
			});
			if (blink) {
				me.shake(3, 5, 300);
				parent.find('.code_4digit').shortblink();
				setTimeout(function() {
					parent.find('.code_4digit input:first').focus();
				}, 500);
			} else {
				parent.find('.code_4digit input').each(function() {
					code += this.value;
				});
				let email = $('#auth .register form .input-email').val();
				$.ajax({
					type: 'POST',
					url: App.auth.endpoint,
					data: {
						email: email,
						hash: md5('20' + "25" + document.location.host + email),
						action: 'partner_register_code',
						activation_code: code
					},
					dataType: 'json',
					success: function (json) {
						if (json.status === 'ok') {
							$('#auth .register_success .code_step1').hide().next().show();
							App.auth.fix_height(); // fix height
						} else {
							parent.find('input[name="activation_code[]"').val('');
							me.shake(3, 5, 300);
							parent.find('.code_4digit').shortblink();
							setTimeout(function() {
								parent.find('.code_4digit input:first').focus();
							}, 500);
						}
					}
				});
			}
			return false;
		});

		$('#auth .register_success .code_step2 form').submit(function () {
			let code = '';
			$('#auth .register_success .code_step1 .code_4digit input').each(function() {
				code += this.value;
			});
			if (!$('#auth .register_success .code_step2 form .input-password').val())
			{
				$('#auth .register_success .code_step2 form .input-password').shortblink().focus();
				return false;
			}
			if ($('#auth .register_success .code_step2 form .input-password').val() != $('#auth .register_success .code_step2 form .input-password-verify').val())
			{
				$('#auth .register_success .code_step2 form .input-password-verify').shortblink().focus();
				return false;
			}
			let email = $('#auth .register form .input-email').val();
			$.ajax({
				type: 'POST',
				url: App.auth.endpoint,
				data: {
					email: email,
					hash: md5('20' + "25" + document.location.host + email),
					password: $('#auth .register_success .code_step2 form .input-password').val(),
					action: 'partner_register_final',
					activation_code: code,
					partner_integrator: App.auth.partner_integrator ? 1 : 0
				},
				dataType: 'json',
				success: function (json) {
					if (json.status === "redirect") {
						document.location.href = json.url ? json.url + (json.query ? '?' + json.query : '') : '';
					} else {
						$('#auth .register_success .message').show().text(json.message);
						App.auth.fix_height();
					}
				}
			});
			return false;
		});

		$('#auth .forgot_success .code_step1 form').submit(function () {
			let blink = false,
				me = $(this),
				code = '',
				parent = $(this).parent();
			parent.find('.code_4digit input').each(function() {
				if (!this.value) blink = true;
			});
			if (blink) {
				me.shake(3, 5, 300);
				parent.find('.code_4digit').shortblink();
				setTimeout(function() {
					parent.find('.code_4digit input:first').focus();
				}, 500);
			} else {
				parent.find('.code_4digit input').each(function() {
					code += this.value;
				});
				let email = $('#auth .forgot form .input-email').val();
				$.ajax({
					type: 'POST',
					url: App.auth.endpoint,
					data: {
						email: email,
						hash: md5('20' + "25" + document.location.host + email),
						action: App.auth.partner ? 'partner_forgot_step_code' : 'forgot_step_code',
						activation_code: code,
						domen: App.auth.forgot_domen
					},
					dataType: 'json',
					success: function (json) {
						if (json.status === "redirect") {
							document.location.href = json.url ? json.url + (json.query ? '?' + json.query : '') : '';
						} else if (json.status === 'ok') {
							$('#auth .forgot_success .code_step1').hide().next().show();
							App.auth.fix_height(); // fix height
						} else {
							parent.find('input[name="activation_code[]"').val('');
							me.shake(3, 5, 300);
							parent.find('.code_4digit').shortblink();
							setTimeout(function() {
								parent.find('.code_4digit input:first').focus();
							}, 500);
						}
					}
				});
			}
			return false;
		});

		$('#auth .forgot_success .code_step2 form').submit(function () {
			let code = '';
			$('#auth .forgot_success .code_step1 .code_4digit input').each(function() {
				code += this.value;
			});
			if (!$('#auth .forgot_success .code_step2 form .input-password').val())
			{
				$('#auth .forgot_success .code_step2 form .input-password').shortblink().focus();
				return false;
			}
			if ($('#auth .forgot_success .code_step2 form .input-password').val() != $('#auth .forgot_success .code_step2 form .input-password-verify').val())
			{
				$('#auth .forgot_success .code_step2 form .input-password-verify').shortblink().focus();
				return false;
			}
			let email = $('#auth .forgot form .input-email').val();
			$.ajax({
				type: 'POST',
				url: App.auth.endpoint,
				data: {
					email: email,
					hash: md5('20' + "25" + document.location.host + email),
					password: $('#auth .forgot_success .code_step2 form .input-password').val(),
					action: 'partner_forgot_final',
					activation_code: code
				},
				dataType: 'json',
				success: function (json) {
					if (json.status === "redirect") {
						document.location.href = json.url ? json.url + (json.query ? '?' + json.query : '') : '';
					} else {
						$('#auth .forgot_success .message').show().text(json.message);
						App.auth.fix_height();
					}
				}
			});
			return false;
		});

		$('#auth .code_step1').find('.code_4digit input').on('keydown', function (e) {
			let key = e.keyCode ? e.keyCode : e.charCode;
			if (key == 8 && this.value.length == 0) {
				$(this).prev().val('').focus();
			}
		}).on('keyup', function(e) {
			let val = $(this).val();
			let o = $(this);
			while (val.length >= 1 && o.length) {
				o.val(val.substr(0, 1));
				val = val.substr(1, 3);
				o = o.next();
			}
			if (!o.length) $(this).parent().parent().find('input[type="submit"]').focus(); else o.focus();
		}).on('paste', function () {
			setTimeout(function(el) {
				$(el).trigger('keyup');
			}, 50, this);
		}).on('focus', function() {
			let o = $(this).prev();
			if (o.length && o.val() == '') {
				while (o.prev().length && o.prev().val() == '') { o = o.prev(); }
				o.focus().select();
			}
			else $(this).select();
		});

		$('#auth .forgot .back, #auth .forgot .back_inline').click(function () {
			App.auth.set_tab('login');
		});

		$('#auth .login .back, #auth .login .back_inline, #auth .register_success .back, #auth .register_multy .back').click(function () {
			App.auth.set_tab('register');
		});

		$('#auth .login_multy .back, #auth .login_multy .back_inline, #auth .forgot_success .back, #auth .forgot_success .back_inline').click(function () {
			App.auth.set_tab('login');
		});

		$('#auth .register .input').focus(function () {
			App.auth.showEffect();
		});

		$('#auth .register .part-bottom .btn, #auth .register_multy .accounts_invis .btn').click(function () {
			$('#auth .login form .input-email').val($('#auth .register form .input-email').val());
			App.auth.set_tab('login');
		});

		$('#auth_overlay').click(function () {
			App.auth.hideLayouts();
		});

		$('#auth .accounts').bind_mousewheel();
	},

	massLogout: function() {
		let i = 0;
		let l = 0;
		if ($('#auth').length) {
			$('#auth .logged .accounts a.param-acc').each(function () {
				$.ajax({
					context: this,
					url: $(this).attr('data-logout'),
					dataType: 'json',
					complete: function () {
						setTimeout(function (el) {
							$(el).addClass('logout_');
						}, i * 300, this);
						setTimeout(function (el) {
							$(el).addClass('logout');
						}, i * 300 + 300, this);
						i++;
					},
				});
			});
		} else {
			l = 1;
			$.getJSON(App.auth.endpoint + '?action=get_logout_links', function(data) {
				l = data.length;
				$.each(data, function (index, item) {
					let url = item[0];
					setTimeout(function(){
						$.ajax({
						url: url,
						dataType: 'json',
						success: function (json) {
							if (json.status === "ok") {
								l = l - 1;
							}
						}
					})}, i * 300);
				});
			});
		}
		var tm_logout = setInterval(function() {
			if (!$('#auth .logged .accounts a.param-acc').not('.logout').length && l === 0) {
				clearTimeout(tm_logout);
				$.ajax({
					type: 'POST',
					url: App.auth.endpoint,
					data: {action: 'logout'},
					dataType: 'json',
					success: function (json) {
						if (json.status === "ok") {
							document.location.reload();
						}
					}
				});
			}
		}, 100);
	},

	showEffect: function () {
		$('#incline-right > div > div').removeClass('liner, liner2');
		$('#incline-left > div > div').removeClass('liner3, liner4');
		$('#incline-right > div > div').addClass('liner');
		$('#incline-left > div > div').addClass('liner3');
		var timerId = setTimeout(function () {
			$('#incline-right > div > div').removeClass('liner');
			$('#incline-left > div > div').removeClass('liner3');
			$('#incline-right > div > div').addClass('liner2');
			$('#incline-left > div > div').addClass('liner4');
			setTimeout(function () {
				$('#incline-right > div > div').removeClass('liner, liner2');
				$('#incline-left > div > div').removeClass('liner3, liner4');
			}, 300);
		}, 300);
	},

	hideLayouts: function () {
		$('body').removeClass('bd_auth');
		if ($(window).width() < 600) $(window).scrollTop(window.lastScrolltop);
		$('#auth .register_success .back').show().next().hide();
		if (App.auth.account_force) {
			this.account_force = false;
			App.auth.partner = true;
			$('#auth').remove();
			$('#auth_overlay').remove();
		}
		App.auth.plan_type = '';
	},

	process_messages: function(e) {
		let data = e.originalEvent.data;
		if (!e.originalEvent.origin.match(/worksection/) || !data) return;
		try {
			let msg = JSON.parse(data);
			switch (msg.command) {
				case 'ws.register':
					App.auth.process_register_response(msg.data);
					break;
				case 'ws.login':
					App.auth.process_login_response(msg.data);
					break;
				default:
					return;
			}
		} catch (e) {	}
	},

	process_register_response(response) {
		if (!$('body').hasClass('bd_auth') && response.status !== "redirect") {
			App.auth.show('register', function () {
				setTimeout(function() {
					App.auth.process_register_response(response);
				}, 500, response);
			});
			return false;
		}
		if (response.status === "redirect") {
			if (response.ga) ga_click(response.ga, response.url ? App.auth.helper_add_url_base(response.url) + (response.query ? '?' + response.query : '') : '');
			else document.location.href = response.url ? App.auth.helper_add_url_base(response.url) + (response.query ? '?' + response.query : '') : '';
		} else if (response.status === "code") { // partnership
			$('#auth .register_success .code_step1').show().next().hide();
			App.auth.set_tab('register_success');
		} else if (response.status === "exists") {
			$('#auth .login .message').show().text(response.message);
			App.auth.set_tab('login');
			$('#auth .login form .input-email').val($('#auth .register form .input-email').val());
		} else if (response.status === "login") {
			$('#auth .register .message').hide();
			$('#auth .register_multy').find('.accounts').hide();
			$('#auth .register_multy').find('.accounts_invis').show();
			App.auth.set_tab('register_multy');
			$('#auth .register_multy .part-bottom a.btn').attr('data-url', response.url ? App.auth.helper_add_url_base(response.url) + (response.query ? '?' + response.query : '') : '').attr('data-ga', response.ga || '')
		} else if (response.status === "domen") {
			if (response.data !== undefined) {
				$('#auth .register .message').hide();
				let html = '';
				for (let key in response.data) {
					if (key > 0) html += '<div class="line"></div>';
					let url = response.url ? App.auth.helper_add_url_base(response.url).replace('register', 'login') + (response.query ? '?' + response.query : '') + '&host=' + response.data[key]['domen'].replace('https://', '') : response.data[key]['domen'] + '/login/' + (response.query ? '?' + response.query : '');
					html += '<a class="param-acc" data-url="' + url + '">' + response.data[key]['img'].replace('src="', 'src="' + response.data[key]['domen']) + '<i><svg><use xlink:href="/assets/img/news.svg#back_arrow"/></svg><b>' + response.data[key].name + '</b><span class="url">' + response.data[key]['domen'].replace(/https?:\/\//, '') + '</span></i></a>';
				}
				$('#auth .register_multy').find('.accounts').show().html(html);
				$('#auth .register_multy').find('.accounts_invis').hide();
				App.auth.set_tab('register_multy');
				$('#auth .register_multy .part-bottom a.btn').attr('data-url', response.url ? App.auth.helper_add_url_base(response.url) + (response.query ? '?' + response.query : '') : '').attr('data-ga', response.ga || '')
			}
		} else if (response.status === "ok") {
			App.auth.set_tab('register_success');
			$('#auth .register_success .text-description a').attr('href', '/support.html?miss_email=1&email=' + encodeURIComponent(email));
			$('#auth .register_success .back').hide().next().show();

		} else {
			const msgDiv = $('#auth .register .message')
			if (response['is_mail_valid_auto'] === 0 && response.messageadd) {
				msgDiv.show().html(response.message + '<br>' + response.messageadd);
				msgDiv.find('a').on('click', function() {
					$('#auth .register form').attr('data-force-validation', '1').submit();
				});
			} else {
				msgDiv.show().text(response.message);
			}
			App.auth.fix_height();
		}
	},

	process_login_response(response) {
		if (response.status === "redirect") {
			document.location.href = response.url ? App.auth.helper_add_url_base(response.url) + (response.query ? '?' + response.query : '') : '';
		} else if (response.status === "domen") {
			if (response.data !== undefined) {
				$('#auth .login .message').hide();
				let html = '';
				for (let key in response.data) {
					if (key > 0) html += '<div class="line"></div>';
					let url = response.url ? App.auth.helper_add_url_base(response.url) + (response.query ? '?' + response.query : '') + '&host=' + response.data[key]['domen'].replace('https://', '') : response.data[key]['domen'] + '/login/' + (response.query ? '?' + response.query : '');
					html += '<a class="param-acc"' + (response.query ? ' data-redirect="yes"' : '') + ' data-url="' + url + '">' + response.data[key]['img'].replace('src="', 'src="' + response.data[key]['domen']) + '<i><svg><use xlink:href="/assets/img/news.svg#back_arrow"/></svg><b>' + response.data[key].name + '</b><span class="url">' + response.data[key]['domen'].replace(/https?:\/\//, '') + '</span></i></a>';
				}
				$('#auth .login_multy').find('.accounts').html(html);
				App.auth.set_tab('login_multy');
			}
		} else {
			$('#auth .login .message').show();
			$('#auth .login .message').text(response.message);
			$('#auth').addClass('noani').css({height: $('#auth .login').outerHeight()});
			window.setTimeout(function () {
				$('#auth').removeClass('noani');
			}, 0);
		}
	},

	forgot_domen: '',
	forgot: function (domen) {
		App.auth.forgot_domen = domen || '';
		let email = $('#auth .forgot form .input-email').val();
		let id_lang = $('body').attr('data-lang') || App.auth.lang;
		$('#auth .forgot_success .text-email').text(email);
		$.ajax({
			type: 'POST',
			url: App.auth.endpoint,
			data: {
				email: email,
				hash: md5('20' + "25" + document.location.host + email),
				action: App.auth.partner ? 'partner_forgot' : 'forgot',
				id_lang: id_lang,
				domen: App.auth.forgot_domen
			},
			dataType: 'json',
			success: App.auth.process_forgot_response
		});
		return false;
	},

	process_forgot_response: function (response) {
		if (response.status === "redirect") {
			document.location.href = response.url ? App.auth.helper_add_url_base(response.url) + (response.query ? '?' + response.query : '') : '';
		} else if (response.status === "domen") {
			if (response.data !== undefined) {
				$('#auth .forgot .message').hide();
				let html = '';
				for (let key in response.data) {
					if (key > 0) html += '<div class="line"></div>';
					html += '<a class="param-acc" data-domen="' + response.data[key]['domen'] + '">' + response.data[key]['img'].replace('src="', 'src="' + response.data[key]['domen']) + '<i><svg><use xlink:href="/assets/img/news.svg#back_arrow"/></svg><b>' + response.data[key].name + '</b><span class="url">' + response.data[key]['domen'].replace(/https?:\/\//, '') + '</span></i></a>';
				}
				$('#auth .forgot_multy').find('.accounts').html(html);
				App.auth.set_tab('forgot_multy');
			}
		} else if (response.status === "ok") {
			App.auth.set_tab('forgot_success');
		} else if (response.status === "code") { // partnership
			$('#auth .forgot_success .code_step1').show().next().hide();
			App.auth.set_tab('forgot_success');
		} else {
			$('#auth .forgot .message').show().text(response.message);
			App.auth.fix_height();
		}
	},
	parse_query: function (queryString) {
		let query = {};
		let pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
		for (let i = 0; i < pairs.length; i++) {
			let pair = pairs[i].split('=');
			query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
		}
		return query;
	},
	helper_add_url_base: function (url) {
		return url.startsWith('https://') ? url : App.auth.url_base + url;
	}
};
$(document).ready(function () {

	$(window).on('message', App.auth.process_messages);

	App.auth.partner = $('body').hasClass('partner');
	$('.button_login').on('click', function (event) {
		event.stopPropagation();
		App.auth.show();
		return false;
	});


	let params = App.auth.parse_query(document.location.search);

	if (params['auth_data']) {
		params['auth_data'] = JSON.parse(params['auth_data']);
		App.auth.show('forgot_success', function() {
			$('#auth .forgot_success .code_step1').hide().next().show();
			$('#auth .forgot form .input-email').val(params['auth_data']['email']);
			let code = params['auth_data']['code'].toString();
			$('#auth .forgot_success .code_step1 .code_4digit input').each(function() {
				this.value = code.substr(0, 1);
				code = code.substr(1);
			});
		});
	}

	$('.header__login, .account__login, .account__onlyLogin').on('click', function(event){
		event.stopPropagation();
		$(this).blur();
		App.auth.show('login');
	});
	$('.header__signup, .account__signup, .account__open, .promo-banner__link.button, .partner-type__link, .price_reg').on('click', function (event) {
		event.preventDefault();
		event.stopPropagation();
		$(this).blur();
		App.auth.partner_integrator = !!$(this).attr('data-partner-integrator');
		App.auth.show();
		if (App.auth.partner && $('a.partner-social-register').length) {
			let partnerSocial = $('a.partner-social-register');
			if (App.auth.partner_integrator) {
				partnerSocial.attr('onclick', partnerSocial.attr('onclick').replace('&register=partner', '&register=partner&partner_integrator=1'))
			} else {
				partnerSocial.attr('onclick', partnerSocial.attr('onclick').replace('&register=partner&partner_integrator=1', '&register=partner'));
			}
		}
	});
	$('.management-tool__link').on('click', function(event) {
		event.stopPropagation();
		$(this).blur();
		$('#auth').remove();
		$('#auth_overlay').remove();
		App.auth.partner = false;
		App.auth.account_force = true;
		App.auth.show();
	});

	$('.account__signup').hover(
		function () {
			$(this).parent().removeClass('alt');
		}
	);

	$('.account__login').hover(
		function () {
			$(this).parent().addClass('alt');
		}
	)
		.focus(function () {
			$(this).parent().addClass('alt');
		})
		.blur(function () {
			$(this).parent().removeClass('alt');
		});
});
;var App = App || {};
App.reg = {
	endpoint: '/api/user/',
	//endpoint: 'https://worksection.com/api/user/',
	init: function () {
		console.log('init App reg');
		App.reg.watch();
	},
	focus: function (el) {
		let o = $(el).parents('.auth_reg');
		if ($(window).width() > 600) $(o).find('.auth_reg_email').focus();
		return false;
	},
	watch: function () {

		$('.auth_reg_email').on('keyup blur paste', function () {
			let o = $(this).parents('.auth_reg');
			let email = $(o).find('.auth_reg_email').val();
			if (email.match(App.validate.email)) {
				if (!o.find('.btn').hasClass('effect-green')) App.reg.showEffect(o);
				o.find('.btn').addClass('effect-green').removeClass('effect-yellow');
			} else if (email) {
				o.find('.btn').addClass('effect-yellow').removeClass('effect-green');
			} else {
				o.find('.btn').removeClass('effect-yellow effect-green');
			}
		}).on('keydown', function (e) {
			let key = e.keyCode ? e.keyCode : e.charCode;
			if (key == 13) {
				let o = $(this).parents('.auth_reg');
				o.find('.btn-default').trigger('click');
				return false;
			}
		});

		$('.auth_reg form').submit(function () {
			let id_lang = $('body').attr('data-lang');
			let o = $(this).parents('.auth_reg');
			let email = $(o).find('.auth_reg_email').val().trim();
			let me = $(this);

			o.find('button.btn-default').css({
				top: o.find('button.btn-default').position().top - o.find('.wrap').position().top,
				left: o.find('button.btn-default').position().left - o.find('.wrap').position().left,
				position: 'absolute'
			});
			o.find('.row-form').css({height: o.find('.row-form').outerHeight()});

			if (email.match(App.validate.email)) {
				o.addClass('loading');
				$.ajax({
					type: "POST",
					url: App.reg.endpoint,
					data: {
						email: email,
						hash: md5('20' + "25" + document.location.host + email),
						action: $('body').hasClass('partner') ? 'partner_register' : 'register_by_email',
						id_lang: id_lang,
						promocode: $('input[name=promocode]').val(),
						ga_cid: ga_cid + ':' + ga_lid,
						ga_typ: ga_typ,
						ga_src: ga_src,
						ga_mdm: ga_mdm,
						ga_cmp: ga_cmp,
						ga_cnt: ga_cnt,
						ga_trm: ga_trm,
						ga_lid: ga_lid,
						ga_adid: ga_adid,
						ga_matchtype: ga_matchtype,
						ga_adposition: ga_adposition,
						ga_device: ga_device,
						ga_device_model: ga_device_model,
						ga_lang: ga_lang,
						ga_placement: ga_placement,
						ga_target: ga_target,
						ga_geo: ga_geo,
						ga_physical_geo: ga_physical_geo,
						ga_network: ga_network,
					},
					dataType: "json",
					success: function(response) {
						App.reg.process_register_response(response, o)
					},
					complete: function () {
						o.removeClass('loading');
					}
				});
				App.reg.showEffect(o);
			}
			return false;
		}).find('.auth_reg_email').focus(function () {
			let o = $(this).parents('.auth_reg');
			App.reg.showEffect(o);
		});

		if ($('.auth_reg').length) $(window).scroll(function () {

			$('.auth_reg').each(function () {
				if ($(window).scrollTop() + $(window).height() >= $(this).offset().top) {
					if (!$(this).attr('data-effect')) {
						App.reg.showEffectRepeat($(this), 2);
					}
					$(this).attr('data-effect', 'on');
				} else {
					$(this).attr('data-effect', '');
				}
			});
		});
	},

	showEffect: function (o) {
		o.find('.right-effect > div > div').removeClass('liner, liner2');
		o.find('.left-effect > div > div').removeClass('liner3, liner4');
		o.find('.right-effect > div > div').addClass('liner');
		o.find('.left-effect > div > div').addClass('liner3');
		setTimeout(function () {
			o.find('.right-effect > div > div').removeClass('liner');
			o.find('.left-effect > div > div').removeClass('liner3');
			o.find('.right-effect > div > div').addClass('liner2');
			o.find('.left-effect > div > div').addClass('liner4');
			setTimeout(function () {
				o.find('.right-effect > div > div').removeClass('liner, liner2');
				o.find('.left-effect > div > div').removeClass('liner3, liner4');
			}, 300);
		}, 300);
	},

	showEffectRepeat: function (o, count) {
		if (!count) count = 1;
		for (let i = 1; i <= 2; i++) {
			setTimeout(function () {
				App.reg.showEffect(o);
			}, 1000 * i);
		}
	},

	process_register_response: function(response, o) {
		let email = $(o).find('.auth_reg_email').val().trim();
		if (response.status === "error") {
			window.setTimeout(function () {
				App.auth.show('register', function () {
					const msgDiv = $('#auth .register .message')
					if (response['is_mail_valid_auto'] === 0 && response.messageadd) {
						msgDiv.show().html(response.message + '<br>' + response.messageadd);
						msgDiv.find('a').on('click', function() {
							$('#auth .register form').attr('data-force-validation', '1').submit();
						});
					} else {
						msgDiv.show().text(response.message);
					}
					$('#auth .register form .input-email').val(email);
				});
			}, 500);
		} else if (response.status === "code") {
			window.setTimeout(function () {
				App.auth.show('register_success', function () {
					$('#auth .register form .input-email').val(email);
				});
			}, 1500);
		} else if (response.status === "exists") {
			window.setTimeout(function () {
				App.auth.show('login', function () {
					$('#auth .login .message').show().text(response.message);
					$('#auth .login form .input-email').val(email);
				});
			}, 1500);
		} else {
			o.addClass('submitted');
			// setTimeout(function () {
			//   o.addClass('submitted__');
			// }, 1500)
			ga_email();
			if (response.status === "redirect") {
				document.location.href = response.url ? response.url + (response.query ? '?' + response.query : '') : '';
			} else if (response.status === "login") {
				window.setTimeout(function () {
					App.auth.show('register_multy', function () {
						$('#auth .register form .input-email').val(email);
						$('#auth .register .message').hide();
						$('#auth .register_multy').find('.accounts').hide();
						$('#auth .register_multy').find('.accounts_invis').show();
						o.fadeOut();
					});
				}, 1500);
			} else if (response.status === "domen") {
				window.setTimeout(function () {
					App.auth.show('register_multy', function () {
						$('#auth .register form .input-email').val(email);
						if (response.data !== undefined) {
							$('#auth .register .message').hide();
							let html = '';
							for (let key in response.data) {
								if (key > 0) html += '<div class="line"></div>';
								html += '<a class="param-acc">' + response.data[key]['img'].replace('src="', 'src="' + response.data[key]['domen']) + '<i><svg><use xlink:href="/assets/img/news.svg#back_arrow"/></svg><b>' + response.data[key].name + '</b><span class="url">' + response.data[key]['domen'].replace(/https?:\/\//, '') + '</span></i></a>';
							}
							$('#auth .register_multy').find('.accounts').show().html(html);
							$('#auth .register_multy').find('.accounts_invis').hide();
							o.fadeOut();
						}
					});
				}, 1500);
			} else if (response.status === "ok") {
				if ($('body').hasClass('partner')) {
					o.find('.text-email').text(email);
				} else {
					$('.activation_code_block input[name="mda"]').val(response.token);
					me.prev().find('.code_4digit input:first').focus();
				}
			}
		}
	},
};
$(document).ready(function () {
	App.reg.init();
});
$(window).on('load', function() {
	$('.in-row .btn').css('display', 'inline-block');
});
;var ws_hint_el = null;
var ws_hint_tm = null;
var ws_hint_tp = 0;

function ws_hint_hide(e) {
	if (ws_hint_tm) {
		clearTimeout(ws_hint_tm);
		ws_hint_tm = null;
	}
	if (ws_hint_el) {
		$('#preview_place').hide();
		$('#hint').hide().find('.in').css({opacity: 0});
		ws_hint_el = null;
	}
}

function ws_hint_show() {
	if (!ws_hint_el) return;
	if ($(window).width()<800) return;
	if (ws_hint_tp == 1) {
		if ($(ws_hint_el).offset().top < $(window).scrollTop() + 200) $('#preview_place').addClass('preview_place_bot').css({
			top: $(ws_hint_el).offset().top + $(ws_hint_el).outerHeight() + 5,
			left: $(ws_hint_el).offset().left
		}).show().html('<img src="' + $(ws_hint_el).attr('data-preview') + '"/>'); else $('#preview_place').removeClass('preview_place_bot').css({
			top: $(ws_hint_el).offset().top - 5,
			left: $(ws_hint_el).offset().left
		}).show().html('<img src="' + $(ws_hint_el).attr('data-preview') + '"/>');
		return;
	}
	if (!$('#hint').length) $('body').append('<div id="hint"><div class="in"></div></div>');
	ds = {}
	dc = '';
	dp = $(ws_hint_el).attr('data-options') || '';
	if ($(ws_hint_el).hasClass('close') && $(window).width() <= 960) return;
	if ($(ws_hint_el).hasClass('help') && !$(ws_hint_el).attr('data-title')) {
		txt = $(ws_hint_el).find('.help__text').html();
		dc = ' hint_hp';
		if ($(ws_hint_el).hasClass('help_big')) dc += ' hint_hpb';
		if ($(ws_hint_el).hasClass('help_t') && $(ws_hint_el).hasClass('help_l')) dp = 'top_left';
		else if ($(ws_hint_el).hasClass('help_t')) dp = 'top';
		else if ($(ws_hint_el).hasClass('help_l')) dp = '';
		else dp = 'right';
	} else {
		txt = htmlenc($(ws_hint_el).attr('data-title'));
		if ($(ws_hint_el).attr('data-title-add')) txt += $(ws_hint_el).attr('data-title-add');
		if ($(ws_hint_el).attr('data-title-add2')) txt += $(ws_hint_el).attr('data-title-add2');
		txt = txt.replace(/%G(.*?)G%/gm, '<span>$1</span>').replace(/%R(.*?)R%/gm, '<span class="red">$1</span>').replace(/%B(.*?)B%/gm, '<b>$1</b>').replace(/%Y(.*?)Y%/gm, '<span class="yellow">$1</span>').replace(/\\n/g, "\n").replace('%UP%', '<span class="ico ico_levelupw"></span>');
		if (txt.substring(0, 1) == '#') txt = $(txt).html();
	}
	if (!txt) return;
	if (is_mobile() && $(ws_hint_el).attr('data-title-nomobile')) return;
	$('#hint').attr('class', '').show().find('.in').html(txt);
	dw = $('#hint .in').outerWidth();
	dh = $('#hint .in').outerHeight();
	if (dp.indexOf('parent2') != -1) ws_hint_el = ws_hint_el.parentNode.parentNode;
	else if (dp.indexOf('parent') != -1) ws_hint_el = ws_hint_el.parentNode;
	if ($(ws_hint_el).attr('data-title-el')) ws_hint_el = $(ws_hint_el).find($(ws_hint_el).attr('data-title-el')).get(0);
	if (dp.indexOf('top_left') != -1) {
		dc += ' hint_t';
		ds = {left: $(ws_hint_el).offset().left + $(ws_hint_el).outerWidth(), top: $(ws_hint_el).offset().top - 5}
	} else if (dp.indexOf('left') != -1 || $(ws_hint_el).hasClass('data-title-l') || $(ws_hint_el).hasClass('data-title-a') || $(ws_hint_el).hasClass('data-title-b') || $(ws_hint_el).hasClass('data-title-l2')) {
		ds = {
			left: $(ws_hint_el).offset().left - 5,
			top: $(ws_hint_el).offset().top + 0.5 * $(ws_hint_el).outerHeight() - 16
		}
	} else if (dp.indexOf('right2') != -1 || $(ws_hint_el).hasClass('data-title-rw') || $(ws_hint_el).hasClass('data-title-r')) {
		dc += ' hint_r';
		ds = {
			left: $(ws_hint_el).offset().left + $(ws_hint_el).outerWidth() + 5,
			top: $(ws_hint_el).offset().top + 0.5 * $(ws_hint_el).outerHeight() - 16
		}
	} else if (dp.indexOf('right') != -1) {
		dc += ' hint_r';
		ds = {left: $(ws_hint_el).offset().left, top: $(ws_hint_el).offset().top + $(ws_hint_el).outerHeight() + 5}
	} else if (dp.indexOf('top') != -1 || $(ws_hint_el).hasClass('data-title-t')) {
		dc += ' hint_t hint_r';
		ds = {left: $(ws_hint_el).offset().left, top: $(ws_hint_el).offset().top - 5}
	} else if (dp.indexOf('center') != -1) {
		ds = {
			left: $(ws_hint_el).offset().left + 0.5 * $(ws_hint_el).outerWidth() + 0.5 * dw,
			top: $(ws_hint_el).offset().top + $(ws_hint_el).outerHeight() + 5
		}
	} else if ($(ws_hint_el).hasClass('data-title-xt')) {
		dc += ' hint_xt';
		ds = {left: $(ws_hint_el).offset().left - 28, top: $(ws_hint_el).offset().top - 11}
		if (ds.left < dw + 5) ds.left = dw + 35;
	} else {
		ds = {
			left: $(ws_hint_el).offset().left + $(ws_hint_el).outerWidth(),
			top: $(ws_hint_el).offset().top + $(ws_hint_el).outerHeight() + 5
		}
		if (ds.left < dw + 5) ds.left = dw + 35;
		if (ds.top + dh > $(window).height() + $(window).scrollTop()) {
			dc += ' hint_t';
			ds.top = $(ws_hint_el).offset().top - 5;
		}
	}
	if (dp.indexOf('hint_gr') != -1 || $(ws_hint_el).hasClass('data-title-gr')) dc += (dc ? ' ' : '') + ' hint_gr';
	if (dp.indexOf('white') != -1 || $(ws_hint_el).hasClass('data-title-l') || $(ws_hint_el).hasClass('data-title-rw')) {
		dc += (dc ? ' ' : '') + ' hint_w';
	}
	if (dp.indexOf('black') != -1) {
		dc += (dc ? ' ' : '') + ' hint_blk';
	}
	if (dp.indexOf('html') != -1) {
		dc += (dc ? ' ' : '') + ' hint_h';
	}
	if ($('#TB_window').length) dc += (dc ? ' ' : '') + ' hint_wm';
	if ($('#hint .in').get(0).scrollWidth > 350) dc += (dc ? ' ' : '') + ' hint_wr';
	$('#hint').attr('class', dc).css(ds);
	setTimeout(function () {
		$('#hint').find('.in').css({opacity: 1});
	}, 0);
}

function ws_hint_over(e) {
	e = (e) ? e : ((event) ? event : null);
	if (!e) return;
	el = (e.target) ? e.target : ((e.srcElement) ? e.srcElement : null);
	if (!el) return;
	if (($(el).attr('data-preview') || $(el).attr('data-title') || $(el).hasClass('help')) || (el.parentNode && (el = el.parentNode) && ($(el).attr('data-preview') || $(el).attr('data-title') || $(el).hasClass('help'))) || (el.parentNode && (el = el.parentNode) && ($(el).attr('data-preview') || $(el).attr('data-title') || $(el).hasClass('help')))) {
		if (e.type == 'touchstart' && $(el).parents().add(el).filter('a, input, label, [onclick]').length) {
			return;
		}
		if (ws_hint_el != el) {
			ws_hint_tp = $(el).attr('data-preview') ? 1 : 0;
			ws_hint_el = el;
			ws_hint_tm = setTimeout(ws_hint_show, 300);
		}
	} else if (!$(ws_hint_el).is(":focus") || !$(ws_hint_el).hasClass('help')) {
		ws_hint_hide();
	}
}

// ------------------------------------------------------------------------------------------------------------------------------------------------------------------

$(document).on('mouseover touchstart', ws_hint_over);
$(document).on('mousewheel DOMMouseScroll', ws_hint_hide);
$(document).ready(function () {
	$('.help').focus(ws_hint_over);
	$('.help').blur(ws_hint_hide);
});
;
jQuery.fn.blink = function () {
	this.each(function () {
		$(this).animate({opacity: 0.1}, function () {
			$(this).animate({opacity: 1}, function () {
				$(this).animate({opacity: 0.1}, function () {
					$(this).animate({opacity: 1}, function () {
						$(this).animate({opacity: 0.1}, function () {
							$(this).animate({opacity: 1});
						});
					});
				});
			});
		});
	});
	return this;
};
jQuery.fn.shortblink = function () {
	this.each(function () {
		$(this).animate({opacity: 0.1}, function () {
			$(this).animate({opacity: 1}, function () {
			});
		});
	});
	return this;
};
jQuery.fn.shake = function (intShakes, intDistance, intDuration) {
	this.each(function () {
		$(this).css("position", "relative");
		for (var x = 1; x <= intShakes; x++) {
			$(this).animate({marginLeft: (intDistance * -1)}, (((intDuration / intShakes) / 4))).animate({marginLeft: intDistance}, ((intDuration / intShakes) / 2)).animate({marginLeft: 0}, (((intDuration / intShakes) / 4)));
		}
	});
	return this;
};
;
function md5(d) {
	var r = md5_m(md5_v(md5_y(md5_x(d), 8 * d.length)));
	return r.toLowerCase()
};

function md5_m(d) {
	for (var _, m = "0123456789ABCDEF", f = "", r = 0; r < d.length; r++) _ = d.charCodeAt(r), f += m.charAt(_ >>> 4 & 15) + m.charAt(15 & _);
	return f
}

function md5_x(d) {
	for (var _ = Array(d.length >> 2), m = 0; m < _.length; m++) _[m] = 0;
	for (m = 0; m < 8 * d.length; m += 8) _[m >> 5] |= (255 & d.charCodeAt(m / 8)) << m % 32;
	return _
}

function md5_v(d) {
	for (var _ = "", m = 0; m < 32 * d.length; m += 8) _ += String.fromCharCode(d[m >> 5] >>> m % 32 & 255);
	return _
}

function md5_y(d, _) {
	d[_ >> 5] |= 128 << _ % 32, d[14 + (_ + 64 >>> 9 << 4)] = _;
	for (var m = 1732584193, f = -271733879, r = -1732584194, i = 271733878, n = 0; n < d.length; n += 16) {
		var h = m, t = f, g = r, e = i;
		f = md5_ii(f = md5_ii(f = md5_ii(f = md5_ii(f = md5_hh(f = md5_hh(f = md5_hh(f = md5_hh(f = md5_gg(f = md5_gg(f = md5_gg(f = md5_gg(f = md5_ff(f = md5_ff(f = md5_ff(f = md5_ff(f, r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 0], 7, -680876936), f, r, d[n + 1], 12, -389564586), m, f, d[n + 2], 17, 606105819), i, m, d[n + 3], 22, -1044525330), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 4], 7, -176418897), f, r, d[n + 5], 12, 1200080426), m, f, d[n + 6], 17, -1473231341), i, m, d[n + 7], 22, -45705983), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 8], 7, 1770035416), f, r, d[n + 9], 12, -1958414417), m, f, d[n + 10], 17, -42063), i, m, d[n + 11], 22, -1990404162), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 12], 7, 1804603682), f, r, d[n + 13], 12, -40341101), m, f, d[n + 14], 17, -1502002290), i, m, d[n + 15], 22, 1236535329), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 1], 5, -165796510), f, r, d[n + 6], 9, -1069501632), m, f, d[n + 11], 14, 643717713), i, m, d[n + 0], 20, -373897302), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 5], 5, -701558691), f, r, d[n + 10], 9, 38016083), m, f, d[n + 15], 14, -660478335), i, m, d[n + 4], 20, -405537848), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 9], 5, 568446438), f, r, d[n + 14], 9, -1019803690), m, f, d[n + 3], 14, -187363961), i, m, d[n + 8], 20, 1163531501), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 13], 5, -1444681467), f, r, d[n + 2], 9, -51403784), m, f, d[n + 7], 14, 1735328473), i, m, d[n + 12], 20, -1926607734), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 5], 4, -378558), f, r, d[n + 8], 11, -2022574463), m, f, d[n + 11], 16, 1839030562), i, m, d[n + 14], 23, -35309556), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 1], 4, -1530992060), f, r, d[n + 4], 11, 1272893353), m, f, d[n + 7], 16, -155497632), i, m, d[n + 10], 23, -1094730640), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 13], 4, 681279174), f, r, d[n + 0], 11, -358537222), m, f, d[n + 3], 16, -722521979), i, m, d[n + 6], 23, 76029189), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 9], 4, -640364487), f, r, d[n + 12], 11, -421815835), m, f, d[n + 15], 16, 530742520), i, m, d[n + 2], 23, -995338651), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 0], 6, -198630844), f, r, d[n + 7], 10, 1126891415), m, f, d[n + 14], 15, -1416354905), i, m, d[n + 5], 21, -57434055), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 12], 6, 1700485571), f, r, d[n + 3], 10, -1894986606), m, f, d[n + 10], 15, -1051523), i, m, d[n + 1], 21, -2054922799), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 8], 6, 1873313359), f, r, d[n + 15], 10, -30611744), m, f, d[n + 6], 15, -1560198380), i, m, d[n + 13], 21, 1309151649), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 4], 6, -145523070), f, r, d[n + 11], 10, -1120210379), m, f, d[n + 2], 15, 718787259), i, m, d[n + 9], 21, -343485551), m = md5_add(m, h), f = md5_add(f, t), r = md5_add(r, g), i = md5_add(i, e)
	}
	return Array(m, f, r, i)
}

function md5_cmn(d, _, m, f, r, i) {
	return md5_add(md5_bit_rol(md5_add(md5_add(_, d), md5_add(f, i)), r), m)
}

function md5_ff(d, _, m, f, r, i, n) {
	return md5_cmn(_ & m | ~_ & f, d, _, r, i, n)
}

function md5_gg(d, _, m, f, r, i, n) {
	return md5_cmn(_ & f | m & ~f, d, _, r, i, n)
}

function md5_hh(d, _, m, f, r, i, n) {
	return md5_cmn(_ ^ m ^ f, d, _, r, i, n)
}

function md5_ii(d, _, m, f, r, i, n) {
	return md5_cmn(m ^ (_ | ~f), d, _, r, i, n)
}

function md5_add(d, _) {
	var m = (65535 & d) + (65535 & _);
	return (d >> 16) + (_ >> 16) + (m >> 16) << 16 | 65535 & m
}

function md5_bit_rol(d, _) {
	return d << _ | d >>> 32 - _
}

;///////////////////////////////////////////////////////////////////////////
//
//  Javascript Swype touches for mobile and app
//  Copyright (c) 2018 Worksection (https://worksection.com)
//  Valeriy Galyant (Valeriy.Galyant@gmail.com)
//  Kyiv, Ukraine
//  This copyright notice MUST stay intact for use
//
///////////////////////////////////////////////////////////////////////////

var touch_x = -1;
var touch_y = -1;
var touch_t = -1;
var touch_px = -1;
var touch_py = -1;
var touch_tm = null;
var touch_scr = 0;
var touch_trg = null;
var app_scroll_avail = true;

function is_app() {
	return $(window).width() < 800;
}

function touch_end2() {
	if (touch_tm) clearTimeout(touch_tm);
	if (touch_t == -1) return;
	if ($('#TB_window').length) {
		$('#TB_ajaxContent, #TB_title').css({opacity: 1});
		$('#TB_ajaxContent').css({paddingTop: 0});
	} else if ($('body').hasClass('bd_auth')) {
		$('#auth').css({marginTop: '', opacity: ''});
	} else if ($('body').hasClass('bd_search') || $('body').hasClass('bd_menu')) {
		setTimeout(function () {
			$('#catalog').css({marginTop: '', opacity: ''});
		}, 500);
	}
	touch_x = -1;
	touch_y = -1;
	touch_t = -1;
	touch_px = -1;
	touch_py = -1;
}

// ------------------------------------------------------------------------------------------------------------------------------------------------------------------

$(document).ready(function () {
	$(window).on('dragstart', function () {
		if ($('body').hasClass('bd_auth') || $('body').hasClass('bd_search') || $('body').hasClass('bd_menu') || $('body').hasClass('modal_win')) return false;
	}).on('mousedown touchstart', function (e) {
		if (!($('body').hasClass('bd_auth') || $('body').hasClass('bd_search') || $('body').hasClass('bd_menu') || $('body').hasClass('modal_win'))) return;
		if (touch_tm) clearTimeout(touch_tm);
		//touch_tm = setTimeout(touch_end2, 500);
		var touch = e;
		if (e.type == 'touchstart') {
			var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] || e; //event.originalEvent && event.originalEvent.touches ? event.originalEvent.touches[0] : e.originalEvent.touches[0];
		}
		//if ($(touch.target).is('textarea')) return;
		touch_x = touch.pageX;
		touch_y = touch.pageY;
		touch_t = 0;
		touch_scr = $(window).scrollTop();
	}).bind_active('mousemove touchmove', function (e) {
		if (touch_t == -1) return; // top-botom
		if (touch_t == 1 || touch_t == 2) e.preventDefault(); // left-right
		var touch = e;
		if (e.type == 'touchmove') {
			var touch = e.touches[0] || e.changedTouches[0] || e;
		}
		this_x = touch.pageX;
		this_y = touch.pageY;
		this_coeff = $('body').width() > 480 ? -1 : 1;
		if (touch_t == 0) {
			if (
				($('body').hasClass('bd_auth') || $('body').hasClass('bd_search') || $('body').hasClass('bd_menu') || $('body').hasClass('modal_win'))
				&& (this_y * this_coeff > touch_y * this_coeff)
				&& (this_coeff == -1 || $(window).scrollTop() == 0)
				&& (Math.abs(this_x - touch_x) + 2 < Math.abs(this_y - touch_y))
			) { // Auth menu, swype down
				touch_t = 1;
				e.preventDefault();
			} else return;
		}
		if (touch_tm) clearTimeout(touch_tm);
		//touch_tm = setTimeout(touch_end2, 500);
		clearSelection();
		if ($('#TB_window').length) {
			var pos = Math.round(0.5 * (this_y - touch_y));
			var opac = Math.min(1, 0.005 * (this_y - touch_y));
			$('#TB_ajaxContent, #TB_title').css({opacity: 1 - opac});
			$('#TB_ajaxContent').css({paddingTop: pos});
			if (pos >= 80) {
				touch_end2();
				tb_remove();
			}
		} else if ($('body').hasClass('bd_auth')) {
			var pos = Math.round(this_coeff * 0.5 * (this_y - touch_y));
			var opac = Math.min(1, this_coeff * 0.005 * (this_y - touch_y));
			if (pos > 0) {
				$('#auth').css({marginTop: this_coeff * pos, opacity: 1 - opac});
				if (pos >= 80) {
					touch_end2();
					$('body').removeClass('bd_auth');
					if ($(window).width() < 600) $(window).scrollTop(window.lastScrolltop);
				}
			} else {
				$('#auth').css({marginTop: '', opacity: ''});
			}
		} else if ($('body').hasClass('bd_search') || $('body').hasClass('bd_menu')) {
			var pos = Math.round(this_coeff * 0.5 * (this_y - touch_y));
			var opac = Math.min(1, this_coeff * 0.005 * (this_y - touch_y));
			if (pos > 0) {
				$('#catalog').css({marginTop: this_coeff * pos, opacity: 1 - opac});
				if (pos >= 80) {
					touch_end2();
					$('body').removeClass('bd_catalog');
					if ($(window).width() < 600) $(window).scrollTop(window.lastScrolltop);
					setTimeout(function () {
						$('body').removeClass('bd_search bd_menu');
					}, 500);
				}
			} else {
				$('#catalog').css({marginTop: '', opacity: ''});
			}
		}
	}).on('mouseup touchend', touch_end2);
	$(window).on('scroll', touch_end2);
});


var passiveSupported = false;
try {
	var options = Object.defineProperty({}, "passive", {
		get: function () {
			passiveSupported = true;
		}
	});
	window.addEventListener("test", null, options);
} catch (err) {
}
$.fn.bind_active = function (events, callback) {
	events = events.split(' ');
	return this.each(function () {
		for (var i = 0; i < events.length; i++) if (events[i]) {
			if (passiveSupported) this.addEventListener(events[i], callback, {passive: false}, false); else this.addEventListener(events[i], callback, false);
		}
	});
};

function clearSelection() {
	if (document.selection && document.selection.empty) {
		document.selection.empty();
	} else if (window.getSelection) {
		var sel = window.getSelection();
		sel.removeAllRanges();
	}
}


scroll_on_wheel = function (e) {
	if (e.type == 'mousewheel') scrollTo = ((e.originalEvent ? e.originalEvent.wheelDelta : e.wheelDelta) * -1);
	else if (e.type == 'DOMMouseScroll') scrollTo = 40 * (e.originalEvent ? e.originalEvent.detail : e.detail);
	$(this).scrollTop(scrollTo + $(this).scrollTop());
	e.preventDefault();
	return false;
}
$.fn.bind_mousewheel = function() {
	$(this).each(function() {
		this.addEventListener('mousewheel', scroll_on_wheel, {passive: false});
		this.addEventListener('DOMMouseScroll', scroll_on_wheel, {passive: false});
	})
};